<template>

</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/page/personcenter/store.vue